import request from 'sb-request'


const resend = (giftMessageId) =>
  request.post('rest/gifts/resend', {
    body: {
      message: giftMessageId,
    },
  })


export default {
  resend,
}
